import { useEffect, useRef } from "react";

/** 回傳一個 debounce 過的事件處理函式，元件 unmount 時自動清除計時器 */
const useDebounce = (event: Function, time: number) => {
  const timer = useRef<ReturnType<typeof setTimeout>>();

  useEffect(() => {
    return () => {
      if (timer.current) clearTimeout(timer.current);
    };
  }, []);

  function debounceEvent(...args: any[]) {
    if (timer.current) clearTimeout(timer.current);
    timer.current = setTimeout(() => event(...args), time);
  }
  return debounceEvent;
};

export default useDebounce;
